import api from "../apis/selectree_api";
import { getAuthHeader } from "../utilities/header";

export function addCommonThunk(tree_id) {
  return async dispatch => {
    return api.post(`/tree/common/${tree_id}`, {}, getAuthHeader()).then(
      response => {
        dispatch(getCommonDataThunk(tree_id));
        return response;
      },
      error => error.response
    );
  };
}

export function getCommonDataThunk(tree_id) {
  return async dispatch => {
    return api.get(`/tree/common/${tree_id}`, {}, getAuthHeader()).then(
      response => {
        dispatch({ type: "TREE_DETAIL_UPDATE", payload: response.data });
        return response;
      },
      error => error.response
    );
  };
}

export function deleteCommonThunk(common_id) {
  return async dispatch => {
    return api.delete(`/tree/common/${common_id}`, getAuthHeader()).then(
      response => {
        return response;
      },
      error => error.response
    );
  };
}

export function updateCommonThunk(common) {
  return async dispatch => {
    return api
      .patch(`/tree/common/${common.common_id}`, common, getAuthHeader())
      .then(
        response => {
          return response;
        },
        error => error.response
      );
  };
}

export function reorderCommonThunk(tree_id, order_map) {
  return async dispatch => {
    return api
      .patch(`/tree/${tree_id}/common/reorder`, order_map, getAuthHeader())
      .then(
        response => {
          dispatch({ type: "TREE_DETAIL_UPDATE", payload: response.data });
          return response;
        },
        error => error.response
      );
  };
}
